export default "__VITE_ASSET__DUq8YoikZLXEejpNZ1KQvg__ 40w";